import { render, staticRenderFns } from "./applyLeave.vue?vue&type=template&id=d87e2502&scoped=true&"
import script from "./applyLeave.vue?vue&type=script&lang=js&"
export * from "./applyLeave.vue?vue&type=script&lang=js&"
import style0 from "./applyLeave.vue?vue&type=style&index=0&id=d87e2502&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87e2502",
  null
  
)

export default component.exports